import { forwardRef, HTMLAttributes } from 'react'

import Logo from '@/components/base/logo'

export type MaskColumnsProps = HTMLAttributes<HTMLDivElement>

const MaskColumns = forwardRef<HTMLDivElement, MaskColumnsProps>(({ ...props }, ref) => {
  return (
    <div ref={ref} data-mask-transition {...props}>
      <div
        className="absolute left-0 top-0 h-full w-full bg-surface-accent-light"
        data-mask-accent
      />
      <div
        className="absolute left-0 top-0 h-full w-[calc(50%+0.1rem)] bg-white-light"
        data-mask-l-white
      />
      <div
        className="absolute right-0 top-0 h-full w-[calc(50%+0.1rem)] bg-white-light"
        data-mask-r-white
      />
      <div className="absolute left-0 top-0 h-full w-full overflow-clip" data-mask-transparent>
        <div className="h-dvh-vh relative flex w-full items-center justify-center" data-mask-loader>
          <Logo className="text-text-accent-light" loop />
        </div>
      </div>
    </div>
  )
})

export default MaskColumns
